import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { CldrIntlService } from '@progress/kendo-angular-intl';
import { userSettingsFeature } from 'src/app/store/features/user-settings/user-settings-feature';

@Injectable({
  providedIn: 'root'
})
export class BizzIntlService extends CldrIntlService {
  private store$ = inject(Store);

  public override firstDay(): number {
    return this.store$.selectSignal(userSettingsFeature.selectFirstDayOfWeekType)() ?? 0;
  }
}
